import React from 'react';

import { WarningOutlined } from '@ant-design/icons';
import { Card, Statistic } from 'antd';
import { useTranslation } from 'react-i18next';

const LowStockWidget = () => {
  const { t } = useTranslation();

  return (
    <Card className="dashboard-widget dashboard-widget--low-stock">
      <Statistic
        title={t('operator.dashboard.widgets.low_stock.title')}
        value={0}
        prefix={<WarningOutlined />}
        valueStyle={{ color: '#ff4d4f' }}
      />
    </Card>
  );
};

export default LowStockWidget;
